import SwiperCarousel from '../utils/swiper-carousel';

import './considerations.css';

// eslint-disable-next-line no-unused-vars
export default (element, data) => {
  const init = () => {
    const navLinks = element.querySelectorAll('[data-slide-btn]');
    const productImages = element.querySelectorAll('[data-slide-product]');
    const updateImage = (activeSlideIndex) => {
      productImages.forEach((imageBlock, index) => {
        // eslint-disable-next-line no-unused-expressions
        if (index === activeSlideIndex) {
          imageBlock.classList.add('opacity-1');
          imageBlock.classList.remove('opacity-0');
          imageBlock.classList.add(
            'top-[-354px]',
            'xl:top-[calc(50%-200px)]',
            '2xl:top-[calc(50%-328px)]',
          );
          imageBlock.classList.remove(
            'top-[-334px]',
            'xl:top-[calc(50%-180px)]',
            '2xl:top-[calc(50%-308px)]',
          );
        } else {
          imageBlock.classList.remove('opacity-1');
          imageBlock.classList.add('opacity-0');
          imageBlock.classList.add(
            'top-[-334px]',
            'xl:top-[calc(50%-180px)]',
            '2xl:top-[calc(50%-308px)]',
          );
          imageBlock.classList.remove(
            'top-[-354px]',
            'xl:top-[calc(50%-200px)]',
            '2xl:top-[calc(50%-328px)]',
          );
        }
      });
    };
    const updateLinks = (activeIndex) => {
      navLinks.forEach((link, index) => {
        if (index === activeIndex) {
          link.classList.remove('after:opacity-0');
          link.classList.add('text-grey-2A');
          link.classList.remove('text-grey-5C');
        } else {
          link.classList.add('after:opacity-0');
          link.classList.remove('text-grey-2A');
          link.classList.add('text-grey-5C');
        }
      });
    };


    const contentSliderElement = document.querySelector('[data-slider-content]');
    const imagesSliderElement = document.querySelector('[data-slider-images]');

    if (!contentSliderElement || !imagesSliderElement) {
      console.error('Slider elements not found');
      return;
    }

    const contentSlider = new SwiperCarousel(contentSliderElement, {
      effect: 'fade',
      speed: 1,
      a11y: true,
      simulateTouch: false,
    });

    const imagesSlider = new SwiperCarousel(imagesSliderElement, {
      effect: 'fade',
      a11y: true,
      simulateTouch: false,
      on: {
        slideChange: () => {
          const activeSlideIndex = imagesSlider.swiper.activeIndex;
          updateImage(activeSlideIndex);
          updateLinks(activeSlideIndex);
        },
      },
    });

    // Link the sliders
    if (contentSlider.swiper && imagesSlider.swiper) {
      contentSlider.updateController(imagesSlider.swiper);
      imagesSlider.updateController(contentSlider.swiper);
    } else {
      console.error('One of the Swiper instances is not initialized');
    }

    // Add event listeners to navigation links
    navLinks.forEach((navLink, index) => {
      navLink.addEventListener('click', (e) => {
        e.preventDefault();
        contentSlider.swiper.slideTo(index);
        imagesSlider.swiper.slideTo(index);
      });
    });
  };

  init();
};
